
import Vue, { watch } from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { Message } from "element-ui";

@Component
export default class ProductEvn extends Vue {

  @Getter productEvns: any;
  @Action("getAllProductEvn") getAllProductEvn: Function;

  @Getter saveForm: any;
  @Action saveProductEvn: Function;
  @Action deleteProductEvn: Function;

  productEvnVisible: boolean = false;
  productEvn: any = {};
  data() {
    return {
      rules: {
        Title: [
          { required: true, message: "名称不能为空", trigger: "blur" },
          { min: 1, max: 512, message: "名称长度不能超过512", trigger: "blur" }
        ],
        IsEnabled: [{ required: true, message: "是否启用不能为空", trigger: "blur" }],
        SortOrder: [{ required: true, message: "排序不能为空", trigger: "blur" }],
        ImageUrl: [
          { required: true, message: "图标URL不能为空", trigger: "blur" },
          { type: 'url', message: '请输入正确的网址格式', trigger: 'blur' },
          { min: 1, max: 512, message: "URL长度不能超过512", trigger: "blur" }
        ],
        ExperienceURL: [
          { required: true, message: "图标不能为空", trigger: "blur" },
          { type: 'url', message: '请输入正确的网址格式', trigger: 'blur' },
          { min: 1, max: 512, message: "URL长度不能超过512", trigger: "blur" }
        ],
        ScenarioURL: [
          { type: 'url', message: '请输入正确的网址格式', trigger: 'blur' },
          { min: 1, max: 512, message: "URL长度不能超过512", trigger: "blur" }
        ]
      },
    };
  }

  mounted() {
    this.getAllProductEvn();
  }

  cellStyle({ row, column, rowIndex, columnIndex }: any) {
    return {
      padding: "6px 0",
    };
  }

  addEvnType() {
    var nextSortNum = null;
    if(this.productEvns.infos && this.productEvns.infos.length > 0){
      nextSortNum = this.productEvns.infos.map((a: any) => a.SortOrder).sort().pop() + 1;
    }
    
    this.productEvn = {EnvironmentType: 1, IsEnabled: 1, SortOrder: nextSortNum};
    this.productEvnVisible = true;
  }

  addProductEvn(row: any) {
    var nextSortNum = null;
    if(row.children && row.children.length > 0){
      nextSortNum = row.children.map((a: any) => a.SortOrder).sort().pop() + 1;
    }
    this.productEvn = {IsEnabled: 1, IsHome: 0, EnvironmentType: 2, ParentGUID: row.ProductEnvironmentGUID, SortOrder: nextSortNum};
    this.productEvnVisible = true;
  }

  editEvn(row: any) {
    this.productEvn = JSON.parse(JSON.stringify(row));
    this.productEvnVisible = true;
  }

  deleteEvn(row: any) {
    var target = row.EnvironmentType == 1 ? row.Title + "分类及其子级环境" : row.Title;
    var notice = "确认删除 <strong>" + target + "</strong> 吗？"
    this.$confirm(notice, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      dangerouslyUseHTMLString: true,
      type: 'warning'
    }).then(() => {
      this.deleteProductEvn({productEvnId:row.ProductEnvironmentGUID}).then(()=>{
        this.getAllProductEvn();
      })
    });
  }

  // 关闭弹窗
  handleClose() {
    this.productEvnVisible = false;
    this.$refs['form'].resetFields();
    this.getAllProductEvn();
  }
  // 确认选择的条目
  confirmbtn() {
    this.$refs["form"].validate((valid: any) => {
      if (valid) {
        this.submitData();
      } else {
        return false;
      }
    });
  }

  submitData() {
    this.saveProductEvn(this.productEvn).then(()=>{
      this.productEvnVisible = false;
      this.getAllProductEvn();
    });
  }
}
